import { render, staticRenderFns } from "./bar-charts.vue?vue&type=template&id=597e0c86&"
import script from "./bar-charts.vue?vue&type=script&lang=js&"
export * from "./bar-charts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports